// Auto-generated from octomil-contracts. Do not edit.

export enum RoutingPolicy {
  Private = "private",
  LocalOnly = "local_only",
  LocalFirst = "local_first",
  CloudFirst = "cloud_first",
  CloudOnly = "cloud_only",
  PerformanceFirst = "performance_first",
  Auto = "auto",
}
